// extracted by mini-css-extract-plugin
module.exports = {"tripos-configuration":"TriposConfiguration_tripos-configuration__3nMlm"};